export default "__VITE_ASSET__eb90bb65__"